<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-position-correct`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M38 16.976C38 8.706 31.284 2 23 2 14.716 2 8 8.705 8 16.976 8 22.49 13 29.498 23 38c10-8.502 15-15.51 15-21.024zM11.766 37a1 1 0 00-1-1H8.81a1 1 0 00-.978.793L6.305 44h.061l-.15.82A1 1 0 007.2 46h33.595a1 1 0 00.983-1.185L41.623 44h.071l-1.527-7.207-.03-.113a1 1 0 00-.948-.68h-1.956l-.117.007a1 1 0 00-.883.993l.006.104a1 1 0 00.016.103L37.27 42H10.728l1.016-4.793a.996.996 0 00.022-.207zM23 6c-6.077 0-11 4.916-11 10.976 0 3.59 3.585 8.97 11 15.703 7.415-6.732 11-12.113 11-15.703C34 10.916 29.076 6 23 6zm-1.243 16.657c.18.18.412.277.648.291h.19a.996.996 0 00.648-.291l1.414-1.414a.997.997 0 00.184-.254l5.402-5.403a1 1 0 000-1.414l-1.415-1.415-.094-.083a1 1 0 00-1.32.083L22.5 17.671l-2.792-2.792a1 1 0 00-1.414 0l-1.414 1.414a1 1 0 000 1.414l3.28 3.282a1 1 0 00.184.254l1.414 1.414z"/></svg>
</template>
<script>

export default {
  name: 'IconPositionCorrect',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
